import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const List = styled.ul`
  list-style: none;
  padding-left: 0;
  li {
    margin: 1rem 0;
  }
`;

const links = [
  /* { url: '../analysing-transparency', title: 'Analysing Transparency In Context' },
  { url: '../design-with-words', title: 'Design With Words' }, */
  { url: '../deconstructing-transparency', title: 'Deconstructing Transparency' },
];

function Navigation( { pageTitle } ) {

  return (
    <nav>
      <p className="h5">More TTC Labs Discovery Exercises</p>
      <List>
        {links.map( (link, i) => {
          let active = '';
          if( pageTitle === link.title ) {
            active = ' active';
          }
          return (
            <li key={i}>
              <a className={`button${active}`} href={link.url} title={link.title}>{link.title}</a>
            </li>
          );
        } )}
      </List>
    </nav>
  )
}

Navigation.propTypes = {
  pageTitle: PropTypes.string.isRequired,
};

export default Navigation;
